<template lang="pug">
  v-container.login(fluid, fill-height)
    v-layout(row, wrap, align-center)
      v-flex(sm6, offset-sm3, lg4, offset-lg4, v-if='!C.state.emailSent')
        v-alert.mb-4(v-if='C.error.active' color='error', icon='warning', value='true')
          | {{ C.error.message }}
        v-container(grid-list-md, text-xs-center)
          v-layout(row, wrap)
            v-flex.mb-3(xs12)
              svg(width='123', height='29', viewbox='0 0 123 29', xmlns='http://www.w3.org/2000/svg')
                g(fill='none', fill-rule='evenodd')
                  path(d='M32 1.284h5.633c.836 0 1.621.083 2.355.249.734.165 1.373.441 1.917.828.545.387.975.9 1.29 1.538.316.64.474 1.424.474 2.355 0 .9-.162 1.68-.486 2.344a4.543 4.543 0 0 1-1.313 1.633 5.592 5.592 0 0 1-1.917.947 8.493 8.493 0 0 1-2.32.307H35.48v5.231H32V1.284zm5.42 7.432c1.894 0 2.84-.82 2.84-2.462 0-.804-.24-1.372-.722-1.704-.48-.331-1.187-.497-2.118-.497h-1.94v4.663h1.94zm11.745-.331h1.799c.915 0 1.613-.194 2.095-.58.48-.387.721-.959.721-1.716 0-.758-.24-1.286-.721-1.586-.482-.3-1.18-.45-2.095-.45h-1.799v4.332zm4.876 8.331l-2.959-5.562h-1.917v5.562h-3.48V1.284h5.563c.82 0 1.59.079 2.308.237.718.158 1.345.422 1.881.793.537.37.963.864 1.278 1.479.316.615.474 1.38.474 2.296 0 1.136-.249 2.07-.746 2.804a4.548 4.548 0 0 1-2 1.645l3.503 6.178h-3.905zM65.88 17c-1.042 0-1.993-.185-2.853-.556a6.201 6.201 0 0 1-2.213-1.598c-.615-.694-1.092-1.538-1.432-2.532-.339-.994-.509-2.123-.509-3.385 0-1.262.17-2.387.51-3.373.339-.986.816-1.814 1.431-2.485a6.147 6.147 0 0 1 2.213-1.538c.86-.355 1.81-.533 2.852-.533 1.042 0 1.992.178 2.852.533.86.355 1.598.871 2.213 1.55.616.678 1.093 1.51 1.432 2.497.34.986.51 2.102.51 3.349 0 1.262-.17 2.39-.51 3.385-.339.994-.816 1.838-1.432 2.532a6.201 6.201 0 0 1-2.213 1.598c-.86.37-1.81.556-2.852.556zm0-3.006c1.057 0 1.893-.454 2.508-1.36.616-.908.923-2.143.923-3.705 0-1.546-.307-2.753-.923-3.621-.615-.868-1.451-1.302-2.509-1.302-1.057 0-1.893.434-2.509 1.302-.615.868-.923 2.075-.923 3.621 0 1.562.308 2.797.923 3.704.616.907 1.452 1.361 2.51 1.361zm9.259-12.71h3.48v12.497h6.106v2.935H75.14V1.284zm11.603 0h3.48v15.432h-3.48V1.284zm6.467 0h9.728v2.935h-6.249v3.574h5.35v2.935h-5.35v5.988h-3.48V1.284zm11.745 0h3.479v15.432h-3.48V1.284zm5.733 7.81c0-1.277.197-2.417.591-3.42.395-1.001.927-1.85 1.598-2.544a6.775 6.775 0 0 1 2.343-1.586A7.43 7.43 0 0 1 118.05 1c.962 0 1.834.201 2.615.604.781.402 1.432.871 1.953 1.408L120.7 5.166a5.412 5.412 0 0 0-1.196-.852c-.402-.206-.872-.308-1.408-.308-.537 0-1.037.114-1.503.343a3.627 3.627 0 0 0-1.219.982c-.347.426-.62.947-.816 1.562-.198.616-.296 1.31-.296 2.083 0 1.594.339 2.829 1.017 3.704.679.876 1.586 1.314 2.722 1.314.631 0 1.184-.126 1.657-.379.473-.252.9-.583 1.278-.994l1.917 2.107c-.647.757-1.384 1.325-2.213 1.704a6.384 6.384 0 0 1-2.686.568 7.79 7.79 0 0 1-2.817-.509 6.576 6.576 0 0 1-2.32-1.503c-.662-.663-1.183-1.487-1.561-2.473-.379-.986-.568-2.126-.568-3.42z', fill='#FFFFFF')
                  path(d='M13.519 17.098L0 28.903v-27a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v14.195a1 1 0 0 1-1 1h-9.481zM5.833 5.53a.5.5 0 0 0-.5.5v6.44h12.834a.5.5 0 0 0 .5-.5V6.03a.5.5 0 0 0-.5-.5H5.833zm-.5 6.94v4.628l5.334-4.627H5.333z', fill='#FFFFFF', opacity='0.5')
        v-card.card--borderless.pa-5
          v-card-title(primary-title='')
            h3.headline.mb-0 Sign Up
          v-card-text
            v-form
              v-text-field.input--box(v-model='C.form.selected.account.firstname', label='First Name', single-line, required='')
              v-text-field.input--box(v-model='C.form.selected.account.lastname', label='Last Name', single-line, required='')
              v-text-field.input--box(v-model='C.form.selected.account.email', label='E-mail', single-line, required='')
          v-card-text
            v-btn(@click='C.form.trigger.submit', block, large, color='primary', :loading="loading2", @click.native="loader = 'loading'") 
                | Create Account
                span(slot="loader")
                    | Creating Account ...
        p.pa-3.text-xs-center.white--text
          | Have an account? 
          router-link.white--text(:to='{name: "MagicSignIn"}')
            | Sign in
          | .

      v-flex(sm6, offset-sm3, lg4, offset-lg4, v-if='C.state.emailSent')
        v-card.pa-5
          v-card-title(primary-title='')
            h2.headline.mb-2
              | We've sent you an email.
            p
              | Please sign up with the link sent to your inbox.

</template>

<script>
import axios from '../../../node_modules/axios/dist/axios.js'

export default {
  data () {
    return {
      C: {
        state: {
          emailSent: false
        },
        form: {
          selected: {
            account: {
              firstname: '',
              lastname: '',
              email: ''
            }
          },
          trigger: {
            submit: () => {
              var component = this

              var submitItem = {
                firstname: this.C.form.selected.account.firstname,
                lastname: this.C.form.selected.account.lastname,
                email: this.C.form.selected.account.email
              }

              axios.post(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/users/sign_up`, submitItem)
              .then(function (response) {
                console.info('Magic Link Sign Up Results: ', response.data)

                if (response.data.code === 200) {
                  component.C.state.emailSent = true
                } else {
                  component.C.error.active = true
                  component.C.error.message = response.data.message
                }
              })
              .catch(function (errorResponse) {
                console.error('errorResponse', errorResponse)
              })
            }
          }
        },
        error: {
          active: false,
          message: ''
        }
      }
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Authentication/MagicSignUp.vue